export default {
  swiperOption: {
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  },
  CurrentTourContent: "Loading your awesome content!",
  GeneratingQuestionsCount: null,
  CurrentTourQuestionsJSON: null,
  QuestionsTotal: 0,
  QuestionsAnswered: 0,
  PointsGenerated: 0,
  AnswerAttempts: 0,
}
